/* eslint-disable */

<template>
  <div class="b-kyc-landing-container">
    <div :class="loading"></div>
    <div v-if="errorMessage">
      <h3 style="text-align: center">Error in fetching data, Please reload the page</h3>
    </div>
    <div style="{padding:15px}" v-else>
      <div class="b-kyc-landing-container__nav">
        <div
          class="b-kyc-landing-container__nav-tab"
          v-for="tab in tabs"
          :key="tab.name"
          v-on:click="changeCurrentTabHandler(tab.name)"
        >
          <div class="b-kyc-landing-container-heading__row">
            <h2 class="b-kyc-landing-container-heading">{{tab.name}}</h2>
            <div v-if="tab.totalCount !==null">
              <h2 class="b-kyc-landing-container-heading">({{tab.totalCount}})</h2>
            </div>
            <div v-if="tab.name == 'Submitted' || tab.name == 'RejectedByAdmin'" >
              <a href v-on:click.stop.prevent="showKycData('2w')" 
                :class="{'b-kyc-data-link__active': allData === false}" >2w</a> |
              <a href v-on:click.stop.prevent="showKycData((tab.name == 'Submitted')? 'submitted': 'rejected')"
                 :class="{'b-kyc-data-link__active': allData === true}" >All</a>
            </div>
          </div>
          <div :class="{'b-skyc-landing-container__active': currentTab === tab.name }"></div>
          <!-- <h1 >KYC Details</h1> -->
        </div>
      </div>
      <div v-if="kyc_details.length>0">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Id</th>
              <th>Name</th>
              <th>PAN <input type="search" v-model="searchByPan" style="margin-left:10px;" placeholder="Search by PAN.." class="bordered"></th>
              <th v-if="currentTab==='Submitted'">CVL Reference ID</th>
              <th>
                Created Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('createdAt','desc')"
                  v-if="sortByCreatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-kyc-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('createdAt','asc')"
                  
                  v-else-if="sortByCreatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('createdAt','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>
                Update Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updatedAt','desc')"
                  
                  v-if="sortByUpdatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-kyc-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updatedAt','asc')"
                
                  v-else-if="sortByUpdatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('updatedAt','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-kyc-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>Email id <input type="search" v-model="searchByEmail" style="margin-left:10px;" placeholder="Search by email.." class="bordered"></th>
              <th
                v-if="$route.params.status=='RejectedByAdmin' || $route.params.status=='RejectedByCVL'"
              >Error Message</th>
              <th @click="removeFilter">
                Kyc Status
                <span v-if="filterFlag">*</span>
              </th>
              <th>
                ConsentForm Checked
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(kyc,index) in all_kyc" :key="kyc.id">
              <td>{{index+1}}</td>
              <td>
                <a href v-on:click.stop.prevent="kycIdDetail(kyc.id)">{{kyc.id}}</a>
              </td>
              <td>{{kyc.name}}</td>
              <td>{{kyc.PAN_number}}</td>
              <td v-if="currentTab==='Submitted'">{{kyc.cvl_reference_id}}</td>

              <td>{{kyc.createdAt | datetimeFormat}}</td>
              <td>{{kyc.updatedAt | datetimeFormat}}</td>
              <td>{{kyc.email}}</td>
              <td
                v-if="$route.params.status=='RejectedByAdmin' || $route.params.status=='RejectedByCVL'"
              >{{kyc.error_message}}</td>
              <td>
                <!-- <a
                href
                v-on:click.stop.prevent="filterStatus(kyc.kyc_form_check_status)"
                >{{kycStatus(kyc.kyc_form_check_status)}}</a>-->
                <span :class="{'b-kyc-rejected':kyc.kyc_form_check_status==='6'}">{{checkKycStatus(kyc.kyc_form_check_status)}}</span>
              </td>
              <td>{{kyc.consent_form | booleanFilter}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="b-kyc-not-found--msg">No record found</div>
    </div>
  </div>
</template>
<script>
import {  mapState } from "vuex";

import Moment from "moment";

export default {
  data() {
    return {
      kyc_details: [],
      loaded: false,
      kycDetails: null,
      filterFlag: false,
      createdDate_asc: null,
      updatedDate_asc: null,
      errorMessage: false,
      // tabs: ["Pending", "Submitted", "RejectedByAdmin", "RejectedByCVL"],
      tabs: [
        { name: "Pending", totalCount: null },
        { name: "Submitted", totalCount: null },
        { name: "RejectedByAdmin", totalCount: null },
        { name: "RejectedByCVL", totalCount: null },
        // { name: "ConsentFormTrue", totalCount: null },
      ],
      currentTab: { name: "Pending", totalCount: null },
      allData: false,
      searchByPan: null,
      searchByEmail: null
    };
  },
  async mounted() {
    this.$store.commit('set_admin_partner', this.$route.params.partner)
    this.$store.commit('set_kyc_verification_type', 'kyc')
    await this.$store
      .dispatch("fetchKycData", 'unverified_kyc_details')
      .then(() => {
        for (let i = 0; i < this.kycData.length; i++) {
          switch (this.kycData[i].kyc_form_check_status) {
            case "2":
              this.tabs[0].totalCount++;
              if(this.kycData[i].consent_form === true )
                this.tabs[4].totalCount++;
              break;
            case "4":
            case "5":
              this.tabs[1].totalCount++;
              break;
            case "3":
              this.tabs[2].totalCount++;
              break;
            case "6":
              this.tabs[3].totalCount++;
              if(this.kycData[i].consent_form === true )
                this.tabs[4].totalCount++;
              break;
          }
        }
       
        this.showKycList();
      })
      .catch(err => {
        this.errorMessage = true});
  },
  methods: {

    kycIdDetail: function(id) {
      this.$router.push({ name: "kyc-details-id", params: { id: id , params: this.admin_partner} });
      this.$store.commit("removeUserDetails");
    },

    filterStatus(status) {
      this.filterFlag = true;
      this.kyc_details = this.kyc_details.filter(
        element => element.kyc_form_check_status === status
      );
    },
    removeFilter() {
      this.filterFlag = false;
      this.showKycList();
    },
    showKycList() {
      // console.log(this.$route.params);
      this.currentTab = this.$route.params.status;

      switch (this.$route.params.status) {
        case "Pending":
          // eslint-disable-next-line no-case-declarations
          let list = this.kycData.filter(
            element => element.kyc_form_check_status === "2" ||
              element.kyc_form_check_status === "6"
          );
          list.sort((a,b)=> b.kyc_form_check_status - a.kyc_form_check_status)
          this.kyc_details = list
          break;
        case "Submitted":
          this.kyc_details = this.kycData.filter(
            element =>
              element.kyc_form_check_status === "4" ||
              element.kyc_form_check_status === "5" 
          );
          
          
          break;
        case "RejectedByAdmin":
          this.kyc_details = this.kycData.filter(
            element => element.kyc_form_check_status === "3"
          );
          break;
        case "RejectedByCVL":
          this.kyc_details = this.kycData.filter(
            element => element.kyc_form_check_status === "6"
          );
          break;
        case "ConsentFormTrue":
          let filteredList = this.kycData.filter(
            element => (element.kyc_form_check_status === "2" ||
              element.kyc_form_check_status === "6") && element.consent_form === true
          );
          filteredList.sort((a,b)=> b.kyc_form_check_status - a.kyc_form_check_status)
          this.kyc_details = filteredList
          break;  
        default:
          this.kyc_details = this.kycData;
      }
  
    },

    showKycData(type) {
      this.tabs[0].totalCount = 0;
      this.tabs[1].totalCount = 0;
      this.tabs[2].totalCount = 0;
      this.tabs[3].totalCount = 0;
      let route_param = this.$route.params.status;
      this.allData = true;

      if(type == 'submitted') {
        route_param = "Submitted";
        this.allData = false;
      }
      if(type == 'rejected') {
        route_param = "RejectedByAdmin";
        this.allData = false;
      }

      this.$store
        .dispatch(`fetchKycData`, type)
          .then(() => {
            for (let i = 0; i < this.kycData.length; i++) {
              switch (this.kycData[i].kyc_form_check_status) {
                case "2":
                  this.tabs[0].totalCount++;
                  break;
                case "4":
                case "5":
                  this.tabs[1].totalCount++;
                  break;
                case "3":
                  this.tabs[2].totalCount++;
                  break;
                case "6":
                  this.tabs[3].totalCount++;
                  break;
              }
            }
            this.changeCurrentTabHandler(route_param);
            this.showKycList();
          })
        .catch(err  => {
          this.errorMessage = true});
    },

    sortByDate(type, sortOrder) {
      let data = [...this.kyc_details];
      if (type === "createdAt") {
        // this.updatedDate_asc = null;
        this.$store.commit("setSortingByDate",{sortByUpdatedDate:null});
        if (sortOrder === "asc") {
          // this.createdDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:true});
          data.sort((a, b) => new Date(b[type]) - new Date(a[type]));
        } else {
          // this.createdDate_asc = false;
            this.$store.commit("setSortingByDate",{sortByCreatedDate:false});
          data.sort((a, b) => new Date(a[type]) - new Date(b[type]));
        }
      }
      if (type === "updatedAt") {
        // this.createdDate_asc = null;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:null});
        if (sortOrder === "asc") {
          // this.updatedDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:true});
          data.sort((a, b) => new Date(b[type]) - new Date(a[type]));
        } else {
          // this.updatedDate_asc = false;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:false});
          data.sort((a, b) => new Date(a[type]) - new Date(b[type]));
        }
      }

      this.kyc_details = data;
    },
    changeCurrentTabHandler(tab) {
      this.currentTab = tab;
      this.$router.replace({ name: 'kyc-details', params: {status: tab, partner: this.admin_partner}});
      this.showKycList();
    },
    checkKycStatus(status){
         switch (status) {
            case "2":
              return 'Pending'
            case "4":
            case "5":
              return 'Submitted'
            case "3":
              return 'Rejected By Admin'
            case "6":
              return 'Rejected By CVL'
          }
    }
  },
  computed: {
    ...mapState({
      kycData: state => state.kycDetails.kycData,
      sortByCreatedDate: state => state.kycDetails.sortByCreatedDate,
      sortByUpdatedDate: state => state.kycDetails.sortByUpdatedDate,
      admin_partner: state => state.kycLogin.admin_partner,
      kyc_verification_type: state => state.kycLogin.kyc_verification_type
      
    }),
    getDetails() {
      return this.$store.state.kycDetails.kycData;
    },
    loading() {
      return {
        loader: this.$store.state.kycDetails.loading
      };
    },
    all_kyc() {
      if(this.searchByPan) {
        return this.kyc_details.filter(obj => {
                if(obj.PAN_number) {
                  return (obj.PAN_number.indexOf(this.searchByPan.toUpperCase()) > -1)
                } else {
                  return false;
                }
              });
      } else if(this.searchByEmail) {
        return this.kyc_details.filter(obj => {
                if(obj.email) {
                  return (obj.email.indexOf(this.searchByEmail) > -1)
                } else {
                  return false;
                }
              });
      } else {
        return this.kyc_details;
      }
    }
  },
  watch: {
    "$route.params.status": function(status) {
      this.currentTab = status;
      this.showKycList();
    }
  },

  filters: {
    datetimeFormat: function(value) {
      if (value) {
        return Moment(value).format("DD/MM/YYYY");
      }
    },
    booleanFilter(value){
    return value? " YES ":" NO ";
    },

  },
};
</script>

<style scoped>
.b-kyc-landing-container {
  margin-top: 40px;
}
.b-kyc-landing-container-heading {
  text-align: center;
  margin-bottom: 8px;
  cursor: pointer;
}
.b-kyc-landing-container__nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 45px;
}
.b-skyc-landing-container__active {
  border: solid 1.5px #2b3d51;
}
tbody tr:hover {
  background-color: aliceblue;
}

table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.b-kyc-landing-container__sort-icon {
  width: 12px;
  height: 12px;
}
.b-kyc-not-found--msg {
  display: flex;
  justify-content: center;
}
.b-kyc-landing-container-heading__row {
  display: flex;
}
.b-kyc-rejected{
color: #ff0000
}
.b-kyc-data-link__active {
  text-decoration: none;
}

/* td a{
  text-decoration: none;
} */

/* Safari */
</style>